export enum RewardShareStatus {
    Created = 'CREATED',
    Processing = 'PROCESSING',
    Finished = 'FINISHED',
    Error = 'ERROR',
}
